import axios from "axios";
import { logOut } from "../store/reducer/auth";
import store from "../store/store.js";
import { API_URL } from "./constants.js";

const api = axios.create({
  baseURL: API_URL,
});

let isRefreshing = false;
let fileAttente = [];

api.interceptors.request.use(
  async (config) => {
    const token = atob(localStorage.getItem("token")) || null;
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const config = error.config;

    // Gestion de l'erreur Unauthorized
    if (error.response.status === 401 && !config._essai) {
      // Si il y a une tentative de rafraichissement du token
      if (isRefreshing) {
        try {
          const nToken = await new Promise((resolve, reject) =>
            fileAttente.push({ resolve, reject })
          );

          config.headers.Authorization = `Bearer ${nToken}`;
          return await axios(config);
        } catch (error) {
          return Promise.reject(error);
        }
      }

      config._essai = true;
      isRefreshing = true;

      try {
        const newToken = await refreshedToken();

        fileAttente.forEach((req) => req.resolve(newToken));
        fileAttente = [];

        config.headers.Authorization = `Bearer ${newToken}`;
        return await axios(config);
      } catch (error) {
        fileAttente.forEach((req) => req.reject(error));
        fileAttente = [];
        store.dispatch(logOut());
        return Promise.reject(error);
      } finally {
        isRefreshing = false;
      }
    }

    return await Promise.reject(error);
  }
);

export default api;

export const refreshedToken = async () => {
  const refresh_token = atob(localStorage.getItem("refresh_token")) || null;
  const { data } = await axios.post(`${API_URL}token/refresh`, {
    refresh_token,
  });

  localStorage.setItem("token", btoa(data.token));
  localStorage.setItem("refresh_token", btoa(data.refresh_token));

  api.defaults.headers.common.Authorization = `Bearer ${data.token}`;
  return data.token;
};
